import { useState, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  notification,
  Row,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { GET, PUT } from "../../../utils/apicalls";
import { API } from "../../../config/api";
import PageHeader from "../../pageHeader/pageheader";

function UpdateVisitors() {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Fetch visitor data on mount
  useEffect(() => {
    fetchVisitorsData();
  }, []);

  // Fetch visitor data function

  const fetchVisitorsData = async () => {
    try {
      setLoading(true);
      const response: any = await GET(`${API.GET_ONE_VISITORS}${id}`, {});

      if (response?.data) {
        // Parse date fields before setting them in the form
        const formattedData = {
          ...response.data,
          date: response.data.date ? moment(response.data.date) : null,
        };

        form.setFieldsValue(formattedData);
      }
    } catch (error: any) {
      console.error("Error fetching Visitors data:", error);
      message.error("Failed to fetch Visitors data.");
    } finally {
      setLoading(false);
    }
  };
  const onFinish = async (values: any) => {
    try {
      let obj = {
        type: values.type,
        visitors_name: values.visitors_name,
        date: values.date,
        visitors_email: values.visitors_email,
        visitors_purpose: values.visitors_purpose,
        visitors_phone: values.visitors_phone,
        description: values.description,
        altPhone: values.altPhone,
      };

      const api = API.UPDATE_VISITORS + id;
      const postRequest = await PUT(api, obj);

      if (postRequest) {
        notification.success({
          message: "Visitor details updated successfully",
        });
        fetchVisitorsData(); // Refresh data after update
        navigate(-1); // Navigate back
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error("Error updating visitors data:", error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    }
  };

  return (
    <div>
      <PageHeader />
      <Card>
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item
                name="type"
                label="Type"
                rules={[{ required: true, message: "Enter type" }]}
              >
                <Input placeholder="Type" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="visitors_name"
                label="Visitor Name"
                rules={[{ required: true, message: "Enter visitor name" }]}
              >
                <Input placeholder="Visitor Name" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="date"
                label="Date"
                rules={[{ required: true, message: "Enter date" }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="visitors_email" label="Visitor Email">
                <Input placeholder="Visitor Email" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item name="visitors_purpose" label="Purpose">
                <Input placeholder="Purpose" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item name="visitors_phone" label="Phone">
                <Input placeholder="Phone" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="description" label="Description">
                <Input placeholder="Description" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="altPhone" label="Alternate Phone">
                <Input placeholder="Alternate Phone" />
              </Form.Item>
            </Col>
          </Row>

          {/* Buttons */}
          <Row className="mt-4" gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Button
                onClick={() => navigate(-1)}
                size="large"
                block
                className="cancel-button"
              >
                Cancel
              </Button>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                block
                className="update-button"
              >
                Update
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
}

export default UpdateVisitors;
